import { useTranslation } from "react-i18next"
import { ScrollWrapper } from "@/components/scroll-wrapper"
import { Header } from "@/layouts/header"
import { DeleteAllAppointments } from "@/modules/admin/advanced/components/delete-all-appointments"
import { EPrescriptionCheck } from "@/modules/admin/advanced/components/e-prescription-check"
import { ExportAssignmentHistory } from "@/modules/admin/advanced/components/export-assignment-history"
import { NodeIdDecoder } from "@/modules/admin/advanced/components/node-id-decoder"
import { SbotSimulator } from "@/modules/admin/advanced/components/sbot-smiulator"
import { SofiaLinkIdentifiers } from "@/modules/admin/advanced/components/sofia-link-identifiers"
import { SofiaEnvironment } from "@/sofia-environment"

export const Advanced = () => {
  const { t } = useTranslation()

  return (
    <>
      <Header title={t("admin.advanced.pageTitle")} />
      <div className="grid-cols-1fr-auto bg-background-subdued grid grid-rows-1" data-testid="advanced-page">
        <ScrollWrapper className="scrollbar-w-1 hover:scrollbar-thumb-surface-pressed scrollbar-track-transparent p-8">
          <div className="grid gap-4">
            <div className="flex gap-4">
              <SbotSimulator />
              <EPrescriptionCheck />
            </div>
            {SofiaEnvironment.CurrentEnvironment !== "production" && (
              <div className="flex gap-4">
                <DeleteAllAppointments />
              </div>
            )}
            <div className="w-189">
              <ExportAssignmentHistory />
            </div>
            <div className="flex gap-4">
              <SofiaLinkIdentifiers />
              <NodeIdDecoder />
            </div>
          </div>
        </ScrollWrapper>
      </div>
    </>
  )
}
